import QuestionTypes from '../enums/QuestionTypes';

const createUserResponseObject = (
  response,
  questions,
  timeTakenToRespond,
  feedbackSubmissionPageIdentifier,
  userId
) => {
  // function for creating response object corresponding to each question
  function createResponse({ questionId, questionType }) {
    // filter out the response for the current question
    const answer = response.answers.filter(({ id }) => {
      return questionId === id;
    });

    // based on the type of question userResponse is created
    let userResponse;
    switch (Object.keys(questionType)[0]) {
      case QuestionTypes.MULTIPLE_CHOICE_QUESTION:
        userResponse = {
          multipleChoiceQuestionTypeResponse: {
            multipleChoiceQuestionResponse: answer[0].answer,
          },
        };
        break;
      case QuestionTypes.RATING_QUESTION:
        userResponse = {
          ratingQuestionTypeResponse: {
            ratingQuestionResponse: answer[0].answer,
          },
        };
        break;
      case QuestionTypes.TEXT_QUESTION:
        userResponse = {
          textQuestionTypeResponse: {
            textQuestionResponse: answer[0].answer,
          },
        };
        break;
      default:
        break;
    }
    return userResponse;
  }

  // For each question create an acknowledgement which includes question and its corresponding response object.
  const acknowledgements = questions.map((question) => ({
    question,
    response: createResponse(question), // creating response object
  }));

  // responseObject that will be stored in the backend
  const userResponseObject = {
    userFeedback: {
      metaData: {
        isAnonymous: false, // TODO: remove this flag.
        responseTimestamp: new Date(Date.now()).toISOString(), // current timestamp when the response is recorded.
        responseCollectionDurationInMilliSecond: timeTakenToRespond, // time taken by user to respond.
        // identifier of the page on which user was when feedback was submitted. It can be a string or a callback
        // function
        feedbackSubmissionPageIdentifier:
          typeof feedbackSubmissionPageIdentifier === 'function'
            ? feedbackSubmissionPageIdentifier()
            : feedbackSubmissionPageIdentifier,
        userId,
      },
      acknowledgements,
    },
  };

  return userResponseObject;
};

export default createUserResponseObject;
